import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-toggle"
//
// Accessible fallback for the desktop hover-dropdown: lets keyboard and
// screen-reader (browse-mode) users open a submenu without depending on
// real hover or focus-within, and without hijacking the parent link's
// normal navigation on click.
export default class extends Controller {
  initialize () {
    this.toggle = this.toggle.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  connect () {
    this.dropdown = this.element.closest(".dropdown")
    this.element.addEventListener("click", this.toggle)
    this.dropdown.addEventListener("keydown", this.handleKeydown)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect () {
    this.element.removeEventListener("click", this.toggle)
    this.dropdown.removeEventListener("keydown", this.handleKeydown)
    document.removeEventListener("click", this.handleOutsideClick)
  }

  toggle (event) {
    event.preventDefault()
    this.open(!this.dropdown.classList.contains("menu-open"))
  }

  handleKeydown (event) {
    if (event.key === "Escape" && this.dropdown.classList.contains("menu-open")) {
      this.open(false)
      this.element.focus()
    }
  }

  handleOutsideClick (event) {
    if (!this.dropdown.contains(event.target)) this.open(false)
  }

  open (shouldOpen) {
    this.dropdown.classList.toggle("menu-open", shouldOpen)
    this.element.setAttribute("aria-expanded", shouldOpen ? "true" : "false")
  }
}
